module.exports = __webpack_public_path__ + "static/media/cg1.7adfab58.jpg";